<template>
  <m-geo-box geo-option="zip" title="2000 ZIP/Carrier Routes/ZIP+4">
    <b-row align-h="center">
      <b-col align-self="center" xl="10" lg="10" md="10" sm="12">
        <h3 class="title"> Paste ZIP Codes, ZIP+4 or Carrier Routes </h3>
     <b-form-radio-group v-model="zipType">
       <b-form-radio v-for="item in zipTypes" :value="item.code" :key="item.code">
         {{item.name}}
       </b-form-radio>
     </b-form-radio-group>
     <b-form-textarea id="textarea1"
                      v-model="zipDesc"
                      placeholder="Copy and paste up to 2,000. Use wrap, space, comma, or semicolon to split."
                      :rows="5"
                      :max-rows="8">
     </b-form-textarea>
     <b-btn class="add-zip" @click="addZip">Add</b-btn>
      </b-col>
    </b-row>
   </m-geo-box>
</template>

<script>
import MGeoBox from "@/components/geo/MGeoBox";
import MGeoZipMenu from "@/components/geo/MGeoZipMenu";

export default {
  components: {
    MGeoBox,
    MGeoZipMenu,
  },
  data() {
    return {
      zipDesc: "",
      zipType: 1,
    };
  },
  computed: {
    geoType() {
      return this.$store.state.geo.geoTypes.Zip;
    },
    zipTypes() {
      return this.$store.state.geo.zipTypes;
    },
  },
  methods: {
    addZip() {
      this.$store.dispatch("order/changeGeoType", this.geoType.Code);
      let zips = this.zipDesc.split(/[\s,;]/);
      this.$http
        .post("PlaceOrder.aspx/GetZipsByZips", {
          zipType: this.zipType,
          zips: zips,
        })
        .then((resp) => {
          let zips = resp.body.d.DataSource;
          for (let zip of zips) {
            this.$store.commit("order/addGeo", {
              GeoKeyCode: zip,
              GeoKeyDesc: zip,
              GeoType: 5,
            });
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.zip-input {
  width: 30%;
  border: 1px solid $color-input-border;
  margin-bottom: 1em;
  margin-right: 1em;
}
.add-zip {
  margin-top: 16px;
}
.custom-radio {
  display: inline-block !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/GeoZipPaste.vue